import { useEffect, useRef } from "react"

type Props = {
  scriptSrc: string
  html: string
}

export default function CoinGeckoWidget({ scriptSrc, html }: Props) {
  const containerRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    // 1) Load script only once
    const alreadyLoaded = document.querySelector(
      `script[src="${scriptSrc}"]`
    ) as HTMLScriptElement | null

    if (!alreadyLoaded) {
      const script = document.createElement("script")
      script.src = scriptSrc
      script.async = true
      document.body.appendChild(script)
    }

    // 2) Inject widget HTML
    if (containerRef.current) {
      containerRef.current.innerHTML = html
    }
  }, [scriptSrc, html])

  return <div ref={containerRef} />
}
